const styles = {
  container: {
    maxWidth: '400px'
  },
  select: {
    '& > select': {
      color: '#f2f2f2',
      background: '#000',
      borderColor: 'transparent',
      position: 'relative',
      transition: 'background 300ms',
      '&:hover': {
        borderColor: 'transparent',
        background: 'rgba(0,0,0,0.4)'
      }
    },
    '& > svg': {
      zIndex: '10',
      color: '#f2f2f2'
    },
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      background: '#343f55',
      width: '34px',
      height: '100%',
      top: 0,
      right: 0,
      borderTopRightRadius: '4px',
      borderBottomRightRadius: '4px',
      pointerEvents: 'none'
    }
  }
}

export default styles
